// extracted by mini-css-extract-plugin
export default {"txtname":"remove_txtname__PYgXG","modalBody":"remove_modalBody__Qod-u","btn":"remove_btn__t6Km7"};